import { FeeItem } from 'shared';

import { PriceListItem } from './PriceDetail';

export function createCartItem(item: FeeItem | undefined) {
  if (!item) return;
  const { label, amount, details } = item;

  const cartItem: PriceListItem = {
    label: label ?? '',
    value: amount ?? 0,
    details: details?.map(({ label, amount }) => ({
      label,
      value: amount,
    })),
  };
  return cartItem;
}
